import Cookies from 'js-cookie';

function getCookie(name) {
    let cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        if (name.trim() === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}

// Gets URL params
function getUrlParams() {
    const params = {};
    const queryString = window.location.search.substring(1);
    const regex = /([^&=]+)=([^&]*)/g;
    let match;
    while (match = regex.exec(queryString)) {
        params[decodeURIComponent(match[1])] = decodeURIComponent(match[2]);
    }
    return params;
}

// Saves parameters as cookies
// Populates form fields with UTM and MC data
function populateUtmFields() {
    const params = getUrlParams();
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'decisely_id', 'mc_eid', 'mc_cid', 'source_account', 'account'];

    utmParams.forEach(param => {
        const paramValue = params[param] ? params[param].toLowerCase() : null;
        
        if (paramValue && paramValue !== 'pantheon_stripped') {
            Cookies.set(param, params[param], { expires: 10 }); 
            if ( param === 'decisely_id' ) {
                Cookies.set('utm_campaign', params[param], { expires: 10 });
            }
        }

        const cookieValue = Cookies.get(param);
        const field = document.querySelector(`.${param} input`);

        if (field) {
            if (paramValue && paramValue !== 'pantheon_stripped') {
                field.removeAttribute('value');
                field.value = params[param]; 
            } else if (!paramValue && cookieValue) {
                field.removeAttribute('value');
                field.value = cookieValue;
            } else if (paramValue === 'pantheon_stripped') {
                field.removeAttribute('value');
                field.value = cookieValue ? cookieValue : '';
            }
        }
    });
}

// Makes sure form is loaded before running
const observer = new MutationObserver((mutations, observer) => {
    const formLoaded = document.querySelector('.utm_source input');
    if (formLoaded) {
        populateUtmFields();
        observer.disconnect();
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

document.addEventListener('DOMContentLoaded', populateUtmFields);

export {getCookie};